import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import ActivityTypesSettingsRow from '../../components/tables/admin/configuration/ActivityTypesSettingsRow';
import FormTypesSettingsRow from '../../components/tables/admin/configuration/FormTypesSettingsRow';
import SystemConfigsSettingsTable from '../../components/tables/admin/configuration/SystemSettingsRow';
import VersionNotesSettingsRow from '../../components/tables/admin/configuration/VersionNotesSettingsRow';
import WasteCodesSettingsRow from '../../components/tables/admin/configuration/WasteCodesSettingsRow';
import WorkTravelZonesSettingsRow from '../../components/tables/admin/configuration/WorkTravelZonesSettingsRow';
import CustomTabs from '../../components/ui/CustomTabs';
import { localStorageKeys } from '../../constants';
import { useAuth } from '../../hooks/useAuth';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';

const ConfigurationAdminPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.ADMINCONFIGURATION) || '0'));
    const [withUsageCount, setWithUsageCount] = useState<boolean>(false);

    const { t } = useTranslation();
    const { user } = useAuth();
    usePageTitle(capitalizeFirstLetter(t('configuration')));

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.ADMINCONFIGURATION, newValue.toString());
    };

    return (
        <div className="fx-c h-100">
            <Header
                title={t('admin')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('configuration')) }]}
                subTitle={capitalizeFirstLetter(t('configuration'))}
                isDateVisible={false}
            ></Header>
            <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabLabels={[t('system'), t('versionNotes'), t('workTravelZones'), t('formTypes'), t('wasteCodes'), t('activityTypes')]}
            />
            {selectedTab == 0 && <SystemConfigsSettingsTable />}
            {selectedTab == 1 && <VersionNotesSettingsRow />}
            {selectedTab == 2 && <WorkTravelZonesSettingsRow />}
            {selectedTab == 3 && <FormTypesSettingsRow />}
            {selectedTab == 4 && <WasteCodesSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 5 && <ActivityTypesSettingsRow withUsageCount={withUsageCount} />}
        </div>
    );
};

export default ConfigurationAdminPage;
